import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const AudioPlayer = ({ src, format, onDownload, display }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    console.log("AudioPlayer recebeu novo src:", src);
    console.log("AudioPlayer recebeu novo format:", format);
    
    if (audioRef.current && src) {
      console.log("Carregando áudio no elemento audio...");
      audioRef.current.load();
    }
  }, [src, format]);

  const mimeType = format === 'ogg' ? 'audio/ogg' : `audio/${format}`;

  return (
    <div style={{ 
      display: display,
      flex: 1,
      minWidth: 0,
      padding: "12px 16px",
      backgroundColor: "#313131ff",
      borderRadius: "12px",
      border: "1px solid #313131ff",
      boxShadow: "0 0 20px rgba(0, 212, 255, 0.1)",
      background: "#313131ff"
    }}>
      <style>{`
        audio {
          width: 100%;
          outline: none;
          --webkit-appearance: none;
          appearance: none;
        }
        
        audio::-webkit-media-controls-panel {
          background: #313131ff);
        }

        audio::-webkit-media-controls-mute-button {
          background-color: transparent;
          cursor: pointer;
          color: #313131ff;
        }

        audio::-webkit-media-controls-play-button {
          background-color: transparent;
          cursor: pointer;
          color: #313131ff;
        }

        audio::-webkit-media-controls-timeline {
          background-color: #fff;
        }

        audio::-webkit-media-controls-volume-slider {
          background-color: #fff;
        }

        audio::-webkit-media-controls-current-time-display,
        audio::-webkit-media-controls-time-remaining-display {
          color: #313131ff;
          font-weight: bold;
        }

        audio::-moz-media-controls {
          background: #313131ff;
          color: #313131ff;
        }
      `}</style>
      
      <audio 
        ref={audioRef} 
        controls 
        key={src}
        style={{ 
          width: "100%",
          height: "40px",
          accentColor: "#ffffffff"
        }}
      >
        <source src={src} type={mimeType} />
        Seu navegador não suporta o elemento de áudio.
      </audio>
    </div>
  );
};

AudioPlayer.propTypes = {
  src: PropTypes.string,
  format: PropTypes.string,
  onDownload: PropTypes.func,
  display: PropTypes.string,
};

AudioPlayer.propTypes = {
  src: PropTypes.string,
  format: PropTypes.string,
  onDownload: PropTypes.func,
  display: PropTypes.string,
};

AudioPlayer.defaultProps = {
  src: "",
  format: "",
  onDownload: () => {},
  display: "none",
};

export default AudioPlayer;